export const DATADOG_SITE = "us5.datadoghq.com";

export const APPLICATION_ID = "1b4472f1-1aed-4ec1-abc8-955ef82667c1";
export const CLIENT_TOKEN = "pub2022b6e2d5e83461d41b6774ce9770bf";
